import React from 'react'

export default function FaceFeature({ scaleX, fill, outline, verticalOffset }) {
  return (
    <g transform={`scale(${scaleX},1) translate(0,${verticalOffset})`}>
      <path
        d="M39.2523 12.4724C38.1723 15.3324 36.1223 21.9424 36.1223 21.9424C36.1223 21.9424 36.3423 17.8724 35.4823 17.1024C34.6723 16.3824 24.2723 12.6924 24.2723 12.6924C24.2723 12.6924 13.6523 16.3824 12.8423 17.1024C11.9823 17.8724 12.3023 21.9424 12.3023 21.9424C12.3023 21.9424 10.2523 15.3324 9.17228 12.4724C8.09228 9.61235 1.09229 2.67236 1.09229 2.67236C0.0222855 32.3624 8.52228 50.4224 12.8423 53.8224C16.3623 56.5924 32.0723 56.5924 35.5823 53.8224C39.9023 50.4224 48.2423 28.8824 47.3323 2.67236C47.3323 2.68236 40.3323 9.61235 39.2523 12.4724Z"
        fill={fill}
        stroke={outline}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M21.352 13.9224C21.352 13.9224 19.132 18.3724 18.782 28.3124C18.432 38.2624 18.782 55.5624 18.782 55.5624"
        stroke={outline}
        strokeWidth="0.5"
        strokeMiterlimit="10"
        fill={fill}
      />
      <path
        d="M18.1922 15.4424C18.1922 15.4424 13.8622 38.9524 15.5022 54.1624"
        stroke={outline}
        strokeWidth="0.5"
        strokeMiterlimit="10"
        fill={fill}
      />
      <path
        d="M22.8724 13.6821C22.8724 13.6821 20.7624 42.6922 22.2824 56.1422"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
        fill={fill}
      />
      <path
        d="M13.0424 17.7822C13.0424 17.7822 10.1124 40.7223 10.0024 50.2023"
        stroke={outline}
        strokeWidth="0.5"
        strokeMiterlimit="10"
      />
      <path
        d="M10.2223 16.0623C10.2223 16.0623 7.5723 32.5323 6.6123 41.9423"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M8.93217 13.0723C8.93217 13.0723 5.92217 28.6722 4.97217 35.9922"
        stroke={outline}
        strokeWidth="0.5"
        strokeMiterlimit="10"
      />
      <path
        d="M6.12221 8.78223C6.12221 8.78223 4.14221 23.3522 3.76221 31.2122"
        stroke={outline}
        strokeWidth="0.5"
        strokeMiterlimit="10"
      />
      <path
        d="M27.082 13.9224C27.082 13.9224 29.302 18.3724 29.652 28.3124C30.002 38.2624 29.652 55.5624 29.652 55.5624"
        stroke={outline}
        strokeWidth="0.5"
        strokeMiterlimit="10"
        fill={fill}
      />
      <path
        d="M30.2422 15.4424C30.2422 15.4424 34.5722 38.9524 32.9322 54.1624"
        stroke={outline}
        strokeWidth="0.5"
        strokeMiterlimit="10"
        fill={fill}
      />
      <path
        d="M25.562 13.6821C25.562 13.6821 27.672 42.6922 26.152 56.1422"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
        fill={fill}
      />
      <path
        d="M35.3921 17.7822C35.3921 17.7822 38.3221 40.7223 38.4321 50.2023"
        stroke={outline}
        strokeWidth="0.5"
        strokeMiterlimit="10"
      />
      <path
        d="M38.2021 16.0623C38.2021 16.0623 40.9221 31.1023 41.8121 41.9423"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M39.502 13.0723C39.502 13.0723 42.582 28.5622 43.462 35.9922"
        stroke={outline}
        strokeWidth="0.5"
        strokeMiterlimit="10"
      />
      <path
        d="M42.3022 8.78223C42.3022 8.78223 44.2822 23.3522 44.6622 31.2122"
        stroke={outline}
        strokeWidth="0.5"
        strokeMiterlimit="10"
      />
    </g>
  )
}
